var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, Form, actions as formActions } from 'react-redux-form';

import { debounce } from "../../utils";
import { t } from "../../I18N";
import { Icon } from "../../UI";

import { searchReferences } from "../actions/actions";

export class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.changeSearchTerm = debounce(this.props.searchReferences, 400);
  }

  componentDidUpdate(prevProps) {
    if (this.props.entityId !== prevProps.entityId) {
      this.resetSearchTerm();
    }
  }

  componentWillUnmount() {
    this.resetSearchTerm();
  }

  resetSearchTerm() {
    this.props.change('relationships/list/search.searchTerm', '');
  }

  resetSearch() {
    this.resetSearchTerm();
    this.props.searchReferences();
  }

  render() {
    const { search } = this.props;
    const searchTerm = search.searchTerm && search.searchTerm.value ? search.searchTerm.value : '';

    return (/*#__PURE__*/
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx(Form, {
        model: "relationships/list/search",
        onSubmit: this.props.searchReferences,
        autoComplete: "off" }, void 0, /*#__PURE__*/

      _jsx("div", { className: `input-group${searchTerm ? ' is-active' : ''}` }, void 0, /*#__PURE__*/
      _jsx(Field, { model: "relationships/list/search.searchTerm" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "search" }), /*#__PURE__*/
      _jsx("input", {
        type: "text",
        placeholder: t('System', 'Search related entities or documents', null, false),
        className: "form-control",
        onChange: this.changeSearchTerm.bind(this),
        autoComplete: "off",
        value: searchTerm }
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "times", onClick: this.resetSearch.bind(this) })
      )
      )
      )
      ));

  }
}








export function mapStateToProps({ relationships }) {
  const { entityId, search } = relationships.list;
  return {
    entityId,
    search
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchReferences,
      change: formActions.change
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);